import { dropDareDifficultyLevelEnum, dropDareTypeEnum } from 'root/src/shared/constants/dropEvent';
import { Platform } from 'root/src/shared/@types/platforms';
export var DropMnemonicIdFilter;
(function (DropMnemonicIdFilter) {
    DropMnemonicIdFilter["All"] = "all_drops";
})(DropMnemonicIdFilter || (DropMnemonicIdFilter = {}));
export var DareStatus;
(function (DareStatus) {
    DareStatus["All"] = "all";
    DareStatus["Active"] = "active";
    DareStatus["Completed"] = "completed";
})(DareStatus || (DareStatus = {}));
export const DARES_PER_PAGE = 6;
export const DEFAULT_DARE_DIFFICULTY_LEVELS = Object.values(dropDareDifficultyLevelEnum);
export const DEFAULT_DARE_TYPES = Object.values(dropDareTypeEnum);
export const DEFAULT_PLATFORMS = [Platform.Twitch, Platform.YouTube, Platform.TikTok];
export const daresTabs = [
    {
        status: DareStatus.All,
        label: 'All',
    },
    {
        status: DareStatus.Active,
        label: 'Active',
    },
    {
        status: DareStatus.Completed,
        label: 'Completed',
    },
];
